/**
 * @hidden
 * Enumeration handling all callback from internal api
 * @module geo/actions
 * @since v 2.0.1
 * @private
 */

/**
 * Enumeration handling all callback from internal api
 */
export enum TypeKeyActionsProxy {
  EVENT_GEO = 'EVENT_GEO',
  // GEO_API_PROXY_READY = 'GEO_API_PROXY_READY',
  INITIALIZE_APPLICATION_STATE = 'INITIALIZE_APPLICATION_STATE',
  UPDATE_MAP_EXTENT = 'UPDATE_MAP_EXTENT',
  MAP_EVENT = 'MAP_EVENT',
  INITIALIZE_MAP_STATE = 'INITIALIZE_MAP_STATE',
  UPDATE_SELECTION = 'UPDATE_SELECTION',
  UPDATE_MARKER_LIST = 'UPDATE_MARKER_LIST',
  UPDATE_FUNCTIONALITIES_STATE = 'UPDATE_FUNCTIONALITIES_STATE',
  UPDATE_FUNCTIONALITY_STATE = 'UPDATE_FUNCTIONALITY_STATE',
  MAP_ENTRIES_UPDATED = 'MAP_ENTRIES_UPDATED',
  SERVICE_DONE = 'SERVICE_DONE',
  SERVICE_EXCEPTION = 'SERVICE_EXCEPTION',
  BASELAYERS_UPDATED = 'BASELAYERS_UPDATED',
  UPDATE_GLOBAL_PARAMETER = 'UPDATE_GLOBAL_PARAMETER',
  UPDATE_FILTER_HISTORY_TIMESTAMP = 'UPDATE_FILTER_HISTORY_TIMESTAMP',
  COMPONENTS_STATE_UPDATED = 'COMPONENTS_STATE_UPDATED',
  APPLICATION_AVAILABLE='APPLICATION_AVAILABLE',
  PENDING_SERVICE = 'PENDING_SERVICE',
  OTHER_ACTION = '__any_other_action_type__'
}
